export const info = [
    {
        path: '/Us',
        textButton: 'CONOCE MÁS',
        image: 'bg-premio',
        name: 'La mejor hamburguesa de La Dorada - Caldas'
    },
    {
        path: '/Bookings',
        textButton: 'RESERVA AQUÍ',
        image: 'bg-kolozoGastrobar',
        name: 'Experiencia única con comida exquisita, buena música y cocteles de autor'
    },
    {
        path: '/Menu',
        textButton: 'VER MENÚ',
        image: 'bg-tacos',
        name: 'Gastronomía Mexicana y Mediterránea'
    }
];
export const infoEvent = {
    path: '/Events',
    textButton: 'Conoce más →',
    image: 'bg-decoracion2',
    name: 'CELEBRACIONES Y EVENTOS EMPRESARIALES',
    description: 'Si estás en busca del lugar perfecto para dar vida a tu evento soñado, Kolozo es la solución ideal.'
}
